import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "as-standing__table" }
const _hoisted_2 = { class: "as-standing__table-row as-standing__table-row-head" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "as-match__team" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "as-standing__table-text" }
const _hoisted_8 = { class: "as-standing__table-column as-text-center" }
const _hoisted_9 = { class: "as-standing__table-column as-text-center" }
const _hoisted_10 = { class: "as-standing__table-column as-text-center" }
const _hoisted_11 = { class: "as-standing__table-column as-text-center" }
const _hoisted_12 = { class: "as-standing__table-column as-text-center as-coulumn-show-full" }
const _hoisted_13 = { class: "as-standing__table-column as-text-center as-c-hsbt as-coulumn-show-full" }
const _hoisted_14 = { class: "as-standing__table-column as-text-center" }
const _hoisted_15 = { class: "as-standing__table-column as-text-center as-coulumn-show-full" }
const _hoisted_16 = { class: "as-standing-tag__list" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "as-standing__table-column as-text-center as-coulumn-show-full" }
const _hoisted_19 = ["src", "alt", "title"]
const _hoisted_20 = {
  key: 0,
  class: "as-promotion"
}

import { ref, computed, nextTick, onMounted } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import StandingLiveScore from "~src/components/standings/StandingLiveScore.vue";
import { usecommonStore } from "~src/stores/CommonStore";
import type {
  IStanding,
  IMatch,
  ITeam,
  IStandingsRow,
  IStandingsTable,
  IPromotion,
  IRecent,
} from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  determineMatchResult,
  getTeamName,
} from "~src/helpers";

const __default__ = {};

interface IProps {
  standing: IStanding;
  match?: IMatch;
  isPopup?: boolean;
  isShowFull?: boolean;
  hideShowFull?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StandingListTab',
  props: {
    standing: {},
    match: {},
    isPopup: { type: Boolean, default: true },
    isShowFull: { type: Boolean, default: false },
    hideShowFull: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const isShowFull = ref(props.isShowFull);
const activeTab = ref("all");
const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: "Sân nhà",
    key: "home",
  },
  {
    title: "Sân khách",
    key: "away",
  },
]);

const columns = [
  {
    title: "#",
    name: "position",
    class: "as-text-center as-standing__table-column-stt as-column-head",
  },
  {
    title: "Đội bóng",
    name: "team_name",
    class: "as-standing__table-column-team as-column-head",
  },
  {
    title: "Trận",
    name: "total",
    class: "as-text-center as-c-total",
  },
  {
    title: "W",
    name: "won",
    class: "as-text-center as-c-w",
  },
  {
    title: "D",
    name: "draw",
    class: "as-text-center as-c-d",
  },
  {
    title: "L",
    name: "loss",
    class: "as-text-center as-c-l",
  },
  {
    title: "G",
    name: "goals",
    class: "as-text-center as-c-g as-coulumn-show-full",
  },
  {
    title: "HSBT",
    name: "goal_diff",
    class: "as-text-center as-c-hsbt as-coulumn-show-full",
  },
  {
    title: "Điểm",
    name: "points",
    class: "as-text-center as-c-point",
  },
];

const sort = ref({
  column: "",
  type: "ASC",
});

const promotions = computed(() => {
  return props.standing.standings.promotions;
});

const tables = computed(() => {
  if (!props.standing?.standings) {
    return [];
  }

  const datas = [];
  for (const table of props.standing.standings.tables) {
    const rows = [];
    for (const row of table.rows) {
      rows.push({
        ...row,
        team_name: getTeamName(props.standing.teams, row.team_id),
      });
    }
    datas.push({
      ...table,
      rows,
    });
  }

  return datas;
});

const getRows = (rows: Array<IStandingsRow>) => {
  return rows?.sort((a: any, b: any) => {
    if (activeTab.value === "all") {
      // chọn sắp xếp
      if (sort.value.column) {
        // sắp xếp string
        if (sort.value.column === "team_name") {
          if (sort.value.type === "DESC") {
            return a.team_name.localeCompare(b.team_name);
          } else {
            return b.team_name.localeCompare(a.team_name);
          }
        } else {
          if (sort.value.type === "DESC") {
            return a[sort.value.column] - b[sort.value.column];
          } else {
            return b[sort.value.column] - a[sort.value.column];
          }
        }
      } else {
        return a.position - b.position;
      }
    } else {
      if (sort.value.column) {
        if (sort.value.column === "team_name") {
          if (sort.value.type === "DESC") {
            return a.team_name.localeCompare(b.team_name);
          } else {
            return b.team_name.localeCompare(a.team_name);
          }
        } else {
          if (sort.value.type === "DESC") {
            return (
              a[`${activeTab.value}_${sort.value.column}`] -
              b[`${activeTab.value}_${sort.value.column}`]
            );
          } else {
            return (
              b[`${activeTab.value}_${sort.value.column}`] -
              a[`${activeTab.value}_${sort.value.column}`]
            );
          }
        }
      } else {
        return (
          a[`${activeTab.value}_position`] - b[`${activeTab.value}_position`]
        );
      }
    }
  });
};

const changeTab = (val: string) => {
  activeTab.value = val;
};

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const getStyleStt = (promotion_id: string) => {
  const promotion = props.standing.standings.promotions.find(
    (item: IPromotion) => item.id == promotion_id
  );

  if (promotion) {
    return {
      backgroundColor: promotion.color,
      color: getContrastColor(promotion.color),
      fontWeight: 700,
    };
  }

  return {};
};

const getGroupName = (table: IStandingsTable) => {
  if (tables.value.length === 1) {
    return "Đội bóng";
  }

  const groupName = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];

  return `Group ${groupName[table.group - 1]}`;
};

const getRowdata = (row: IStandingsRow, field: string) => {
  if (field === "total") {
    if (activeTab.value === "all") {
      return row.total;
    } else if (activeTab.value === "home") {
      return row.home_total;
    } else {
      return row.away_total;
    }
  } else if (field === "won") {
    if (activeTab.value === "all") {
      return row.won;
    } else if (activeTab.value === "home") {
      return row.home_won;
    } else {
      return row.away_won;
    }
  } else if (field === "draw") {
    if (activeTab.value === "all") {
      return row.draw;
    } else if (activeTab.value === "home") {
      return row.home_draw;
    } else {
      return row.away_draw;
    }
  } else if (field === "loss") {
    if (activeTab.value === "all") {
      return row.loss;
    } else if (activeTab.value === "home") {
      return row.home_loss;
    } else {
      return row.away_loss;
    }
  } else if (field === "goals") {
    if (activeTab.value === "all") {
      return row.goals;
    } else if (activeTab.value === "home") {
      return row.home_goals;
    } else {
      return row.away_goals;
    }
  } else if (field === "goals_against") {
    if (activeTab.value === "all") {
      return row.goals_against;
    } else if (activeTab.value === "home") {
      return row.home_goals_against;
    } else {
      return row.away_goals_against;
    }
  } else if (field === "goal_diff") {
    if (activeTab.value === "all") {
      return row.goal_diff;
    } else if (activeTab.value === "home") {
      return row.home_goal_diff;
    } else {
      return row.away_goal_diff;
    }
  } else if (field === "points") {
    if (activeTab.value === "all") {
      return row.points;
    } else if (activeTab.value === "home") {
      return row.home_points;
    } else {
      return row.away_points;
    }
  }
};

const getRecentTitle = (recent: IRecent) => {
  return `${recent.home_scores[0]}:${recent.away_scores[0]} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};

const activeItems = ref<HTMLDivElement | null>(null);
const standingRef = ref<HTMLDivElement | null>(null);

const scrollToActiveItem = (container: HTMLDivElement, activeItem: HTMLDivElement) => {
  try {
    if (!container || !activeItem) return;

    const containerRect = container.getBoundingClientRect();
    const activeItemRect = activeItem.getBoundingClientRect();

    const scrollLeft = container.scrollLeft + activeItemRect.left - containerRect.left;

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  } catch (error) {
    console.error('Error in scrollToActiveItem:', error);
  }
}

const handleShowFull = async () => {
  isShowFull.value = !isShowFull.value;
  await nextTick();

  if (!standingRef.value || !isShowFull.value) return;

  const _tables = standingRef.value.querySelectorAll<HTMLDivElement>(".as-standing__table") ?? [];
  if (!_tables?.length) return;

  Array.from(_tables).forEach((table) => {
    try {
      const activeItem = table.querySelector<HTMLDivElement>(".as-scroll-item-active");
      if (!activeItem) return;

      requestAnimationFrame(() => {
        setTimeout(() => {
          scrollToActiveItem(table, activeItem);
        }, 100);
      });
    } catch (error) {
      console.error('Error scrolling to active item:', error);
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (tables.value.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`as-parent-standing as-parent-standing-${siteName.value}`),
        ref_key: "standingRef",
        ref: standingRef
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["as-standing__top", {
        'as-standing__tabs-center': _ctx.hideShowFull,
      }])
        }, [
          _createVNode(TabsBtn, {
            tabs: tabs.value,
            activeTab: activeTab.value,
            onChange: changeTab
          }, null, 8, ["tabs", "activeTab"]),
          (!_ctx.hideShowFull)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["as-menu", {
          'as-active': isShowFull.value,
        }]),
                onClick: handleShowFull
              }, [
                _createVNode(IconMenu)
              ], 2))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["as-standing", {
        'as-show-full': isShowFull.value,
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup':
          _ctx.isPopup,
      }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tables.value, (table, key) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                    return _createElementVNode("div", {
                      key: column.name,
                      onClick: ($event: any) => (sortData(column.name)),
                      class: _normalizeClass(`as-standing__table-column ${column.class}`),
                      type: "button"
                    }, [
                      _createTextVNode(_toDisplayString(column.name === "team_name" ? getGroupName(table) : column.title) + " ", 1),
                      (sort.value.column === column.name)
                        ? (_openBlock(), _createBlock(IconArrownDown, {
                            key: 0,
                            class: _normalizeClass(["as-d-inline-flex", {
                  'as-sort-down': sort.value.type === 'ASC',
                  'as-sort-up': sort.value.type === 'DESC',
                }])
                          }, null, 8, ["class"]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_3)
                  }), 64)),
                  _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"as-standing__table-column as-column-performance as-text-center as-coulumn-show-full\"> Phong độ <svg width=\"23\" height=\"10\" viewBox=\"0 0 23 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_2793_18912)\"><path d=\"M22.7365 5.27651C22.7362 5.27662 22.736 5.27676 22.7357 5.27688L18.0412 7.30813C17.6895 7.4603 17.1206 7.45973 16.7705 7.3068C16.4205 7.15389 16.4219 6.90656 16.7736 6.75438L19.9255 5.39063L0.898438 5.39063C0.402231 5.39063 9.64331e-08 5.21574 1.05863e-07 5C1.15294e-07 4.78426 0.402231 4.60938 0.898438 4.60938L19.9254 4.60938L16.7736 3.24563C16.4219 3.09344 16.4206 2.84612 16.7706 2.69321C17.1207 2.54026 17.6896 2.53973 18.0412 2.69188L22.7357 4.72313C22.736 4.72325 22.7362 4.72338 22.7365 4.7235C23.0884 4.87619 23.0873 5.12432 22.7365 5.27651Z\" fill=\"#00B242\"></path></g><defs><clipPath id=\"clip0_2793_18912\"><rect width=\"23\" height=\"10\" fill=\"white\" transform=\"matrix(1 4.37114e-08 4.37114e-08 -1 0 10)\"></rect></clipPath></defs></svg></div>", 1)),
                  _createElementVNode("div", {
                    ref_for: true,
                    ref_key: "activeItems",
                    ref: activeItems,
                    class: "as-standing__table-column as-scroll-item-active as-column-next as-text-center as-coulumn-show-full"
                  }, " Tiếp ", 512)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRows(table.rows), (row, keyRow) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: keyRow,
                    class: _normalizeClass(["as-standing__table-row", {
              active:
                _ctx.match?.home_team_id === row.team_id ||
                _ctx.match?.away_team_id === row.team_id,
            }])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["as-standing__table-column as-standing__table-column-stt as-text-center", {
                'as-stt-popup': _ctx.isPopup,
              }])
                    }, [
                      _createElementVNode("div", {
                        class: "as-stt",
                        style: _normalizeStyle(getStyleStt(row.promotion_id))
                      }, _toDisplayString(row.position), 5)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["as-standing__table-column as-standing__table-column-team", {
                'as-team-popup': _ctx.isPopup,
              }])
                    }, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.getLinkTeamDetail(row.team_id, row.team_name, true)),
                        class: _normalizeClass(["as-match__team-group", {
                  'as-match__team-group-live': row.live_score
                }])
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            src: _ctx.getImgUrlBySport('team', row.team_id),
                            class: "as-match__team-logo",
                            alt: row.team_name
                          }, null, 8, _hoisted_6),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(row.team_name), 1)
                        ]),
                        (row.live_score)
                          ? (_openBlock(), _createBlock(StandingLiveScore, {
                              key: 0,
                              standing: row
                            }, null, 8, ["standing"]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_4)
                    ], 2),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(getRowdata(row, "total")), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(getRowdata(row, "won")), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(getRowdata(row, "draw")), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(getRowdata(row, "loss")), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(getRowdata(row, "goals")) + ":" + _toDisplayString(getRowdata(row, "goals_against")), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(getRowdata(row, "goal_diff")), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(getRowdata(row, "points")), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRecent(row), (recent, keyRecent) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: keyRecent,
                            class: _normalizeClass(`as-standing-tag as-standing-tag__${_unref(determineMatchResult)(
                    recent,
                    row.team_id
                  ).charAt(0)}`),
                            title: getRecentTitle(recent)
                          }, _toDisplayString(_unref(determineMatchResult)(recent, row.team_id).charAt(0)), 11, _hoisted_17))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (row.next_match)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: 
                  _ctx.getImgUrlBySport(
                    'team',
                    row.next_match.away_team?.id === row.team_id
                      ? row.next_match.home_team?.id
                      : row.next_match.away_team?.id
                  )
                ,
                            class: "as-match__team-logo",
                            alt: 
                  row.next_match.away_team?.id === row.team_id
                    ? row.next_match.home_team?.name
                    : row.next_match.away_team?.name
                ,
                            title: 
                  row.next_match.away_team?.id === row.team_id
                    ? row.next_match.home_team?.name
                    : row.next_match.away_team?.name
                
                          }, null, 8, _hoisted_19))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ], 64))
            }), 128))
          ]),
          (promotions.value && promotions.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotions.value, (promotion, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: "as-promotion-item"
                  }, [
                    _createElementVNode("div", {
                      class: "as-promotion-circle",
                      style: _normalizeStyle({
              background: promotion.color,
            })
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(promotion.name), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})